export const API_BASE = 'https://test.johshopping.com';

export const apiUrl = (path) => `${API_BASE}${path}`;

export const storageUrl = (path) => (
  path ? `${API_BASE}/${path.replace(/^storage\//, 'contract-storage/')}` : ''
);

export async function request(path, { token, method = 'GET', body, form = false } = {}) {
  const headers = {};
  if (!form) headers['Content-Type'] = 'application/json';
  if (token) headers.Authorization = `Bearer ${token}`;

  const response = await fetch(apiUrl(path), {
    method,
    headers,
    body: form ? body : body ? JSON.stringify(body) : undefined,
  });

  const contentType = response.headers.get('content-type') || '';
  const data = contentType.includes('application/json') ? await response.json() : await response.blob();
  if (!response.ok) throw new Error(data.message || 'Request failed');
  return data;
}

export async function downloadWithToken(path, token) {
  const response = await fetch(apiUrl(path), {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) throw new Error('Download failed');
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = '';
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

export async function openWithToken(path, token) {
  const previewWindow = window.open('about:blank', '_blank');
  if (previewWindow) previewWindow.opener = null;
  const response = await fetch(apiUrl(path), {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) {
    previewWindow?.close();
    throw new Error('Preview failed');
  }
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  if (previewWindow) {
    previewWindow.location = url;
  } else {
    window.open(url, '_blank');
  }
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
